import React, {Component} from 'react';
import {Button, Modal, ModalHeader} from 'reactstrap';
import AddLeadForm from "./AddLeadForm";
import {APIClient} from "../../../../utils/APIClient";
import { withTranslation } from 'react-i18next';

class AddLeadModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleFormSubmitted(data) {
        let postData = this.buildDataForPost(data);

        new APIClient(`${this.props.crmApiURL}/lead`).call('POST', postData).then((response) => {
            if (response.status === 'OK') {
                this.toggle();
                this.props.onLeadAdd(response.data.lead_id)
            } else {
                alert(data['error_message']);
            }
        });
    }

    buildDataForPost(data) {
        let postData = {
            name: data.name,
            phone_number: data.phone,
            email: data.email,
            message: data.message
        };

        data.extraFields.forEach(extraField => {
            if (extraField.name !== '') {
                postData[extraField.name] = extraField.value
            }
        });
        return postData;
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Button className="btn -alt" onClick={this.toggle}>{t('add_lead_modal.add_offline_lead_button')}</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>{t('add_lead_modal.title')}</ModalHeader>
                    <AddLeadForm closeModal={this.toggle} onLeadAdded={this.handleFormSubmitted}/>
                </Modal>
            </div>
        );
    }
}

export default withTranslation()(AddLeadModal);

